module.exports = __webpack_public_path__ + "52191e627f71bc8b543cdbc4d73dda69.pdf";